async function toPromise(callback) {
  return callback();
}

// TODO Use the postTask type for the callback and return type once the current TypeScript version supports
//  forwarding the generic to the function (>=v4.7.4)
export function postTask(callback, options) {
  // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
  // do not pay the performance cost (e.g. bundle size, runtime, etc).
  if (typeof globalThis.scheduler === 'undefined') {
    // Only load the polyfill if we are using the background priority
    if (options.priority === 'background') {
      // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
      // eslint-disable-next-line import/dynamic-import-chunkname
      return import('scheduler-polyfill').then(() => scheduler.postTask(callback, options));
    }
    return toPromise(callback);
  }
  return scheduler.postTask(callback, options);
}